import {TYPE_OF_POST} from "../actions/types"

const INITIAL_STATE = {
    type:"",
};
export default (state=INITIAL_STATE ,action)=>{
    switch(action.type) {
        case TYPE_OF_POST:
            return {
                type:action.payload
            }
        default:
            return state
    }
}

